import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { formatTimeAgo, formatDateTime } from '../utils/formatters';

export default function InventoryReorder() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/api/inventory/reorder');
      setItems(data.items || []);
    } catch (err) { console.error('Reorder list error:', err); }
    setLoading(false);
  }, []);

  useEffect(() => { fetchItems(); }, [fetchItems]);

  async function markRestocked(item) {
    if (!window.confirm(`Mark "${item.name}" as restocked? This clears the reorder flag without changing the stock count. Use the item's adjust panel to record an actual stock-in.`)) return;
    try {
      await api.post(`/api/inventory/${item.id}/clear-reorder`);
      fetchItems();
    } catch (err) { alert(err.response?.data?.error || 'Failed to clear flag'); }
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Reorder List</h2>
        <Link to="/inventory" className="btn btn-secondary">Back to Inventory</Link>
      </div>

      {loading && <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><div className="spinner" /></div>}

      {!loading && items.length === 0 && (
        <div className="card" style={{ padding: 32, textAlign: 'center', color: 'var(--text-light)' }}>
          No items need reordering. Nice.
        </div>
      )}

      {!loading && items.length > 0 && (
        <div className="card">
          <div className="table-container sticky-col">
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Location</th>
                  <th>Category</th>
                  <th style={{ textAlign: 'right' }}>Stock</th>
                  <th style={{ textAlign: 'right' }}>Min</th>
                  <th>Last Counted</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.map(item => (
                  <tr key={item.id}>
                    <td><strong>{item.name}</strong></td>
                    <td>{item.location ? <span className="badge badge-info">{item.location}</span> : <span style={{ color: 'var(--text-light)' }}>—</span>}</td>
                    <td><span className="badge badge-default">{item.category || 'Uncategorized'}</span></td>
                    <td style={{ textAlign: 'right', fontWeight: 600, color: item.current_stock <= item.min_stock ? 'var(--danger)' : undefined }}>
                      {item.current_stock} {item.unit}
                    </td>
                    <td style={{ textAlign: 'right', color: 'var(--text-light)' }}>{item.min_stock}</td>
                    <td style={{ fontSize: 12, color: 'var(--text-light)' }}>
                      {item.last_counted_at ? (
                        <span title={formatDateTime(item.last_counted_at)}>
                          {formatTimeAgo(item.last_counted_at)}{item.last_counted_by_name ? ` by ${item.last_counted_by_name}` : ''}
                        </span>
                      ) : <em>never</em>}
                    </td>
                    <td><button className="btn btn-sm btn-secondary" onClick={() => markRestocked(item)}>Mark Restocked</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
